var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotification({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0186 2.90991C8.70862 2.90991 6.01862 5.59991 6.01862 8.90991V11.7999C6.01862 12.4099 5.75862 13.3399 5.44862 13.8599L4.29862 15.7699C3.58862 16.9499 4.07862 18.2599 5.37862 18.6999C9.68862 20.1399 14.3386 20.1399 18.6486 18.6999C19.8586 18.2999 20.3886 16.8699 19.7286 15.7699L18.5786 13.8599C18.2786 13.3399 18.0186 12.4099 18.0186 11.7999V8.90991C18.0186 5.60991 15.3186 2.90991 12.0186 2.90991Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.8719 3.19994C13.5619 3.10994 13.2419 3.03994 12.9119 2.99994C11.9519 2.87994 11.0319 2.94994 10.1719 3.19994C10.4619 2.45994 11.1819 1.93994 12.0219 1.93994C12.8619 1.93994 13.5819 2.45994 13.8719 3.19994Z",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.0195 19.0601C15.0195 20.7101 13.6695 22.0601 12.0195 22.0601C11.1995 22.0601 10.4395 21.7201 9.89953 21.1801C9.35953 20.6401 9.01953 19.8801 9.01953 19.0601",
    stroke: "#667085",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.6d77c154d9f9063b61bfa2ebad41c01d.svg";
export { ForwardRef as ReactComponent };